import React from 'react';
import { Button } from '@mui/material';
import { Download as DownloadIcon } from '@mui/icons-material';
import { useDownloadServicesMutation } from '../../../../services/ConfigurationService';

interface ServiceDownloadCsvProps {
  company: string;
  centerId: string;
  disabled?: boolean;
  onError?: (error: string) => void;
}

const ServiceDownloadCsv: React.FC<ServiceDownloadCsvProps> = ({ 
  company, 
  centerId, 
  disabled = false,
  onError 
}) => {
  const [downloadServices, { isLoading: isDownloading }] = useDownloadServicesMutation();

  const handleDownload = async () => {
    if (!company || !centerId) {
      console.warn('Company and Center ID are required');
      return;
    }
    
    try {
      const blob = await downloadServices({
        company,
        centerId
      }).unwrap();
      
      // Create download link
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `Services_${company}_${centerId}_${new Date().toISOString().slice(0, 10)}.csv`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (err: any) {
      console.error('Download failed:', err);
      onError?.(err?.data?.message || err?.message || 'Download failed');
    }
  };

  const isDisabled = disabled || !company || !centerId || isDownloading;

  return (
    <Button
      variant="outlined"
      startIcon={<DownloadIcon />}
      onClick={handleDownload}
      size="small"
      disabled={isDisabled}
    >
      Download CSV
    </Button>
  );
};

export default ServiceDownloadCsv;